import React, { useEffect, useState } from 'react';
import confetti from 'canvas-confetti';
interface CelebrationEffectProps {
  trigger: boolean;
  message?: string;
  points?: number;
}
export function CelebrationEffect({
  trigger,
  message,
  points
}: CelebrationEffectProps) {
  const [show, setShow] = useState(false);
  useEffect(() => {
    if (trigger) {
      setShow(true);
      // Confetti effect
      const duration = 3000;
      const animationEnd = Date.now() + duration;
      const defaults = {
        startVelocity: 30,
        spread: 360,
        ticks: 60,
        zIndex: 9999
      };
      function randomInRange(min: number, max: number) {
        return Math.random() * (max - min) + min;
      }
      const interval = setInterval(function () {
        const timeLeft = animationEnd - Date.now();
        if (timeLeft <= 0) {
          return clearInterval(interval);
        }
        const particleCount = 50 * (timeLeft / duration);
        confetti({
          ...defaults,
          particleCount,
          origin: {
            x: randomInRange(0.1, 0.3),
            y: Math.random() - 0.2
          }
        });
        confetti({
          ...defaults,
          particleCount,
          origin: {
            x: randomInRange(0.7, 0.9),
            y: Math.random() - 0.2
          }
        });
      }, 250);
      // Hide message after 3 seconds
      setTimeout(() => {
        setShow(false);
      }, 3000);
      return () => clearInterval(interval);
    }
  }, [trigger]);
  if (!show) return null;
  return <div className="fixed inset-0 flex items-center justify-center z-50 pointer-events-none" data-id="element-46">
      <div className="bg-white dark:bg-slate-800 rounded-3xl shadow-2xl p-8 max-w-md mx-4 animate-bounce" data-id="element-47">
        <div className="text-center" data-id="element-48">
          <div className="text-6xl mb-4" data-id="element-49">🎉</div>
          <h3 className="text-2xl font-bold text-gray-900 dark:text-white mb-2" data-id="element-50">
            {message || 'Amazing Work!'}
          </h3>
          {points && <p className="text-lg text-green-600 dark:text-green-400 font-semibold" data-id="element-51">
              +{points} points earned! 🌟
            </p>}
        </div>
      </div>
    </div>;
}